/* eslint-disable import/prefer-default-export */
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const COMMAND = project.getFeature(feature.getSettingValue('COMMAND'));
    if (!COMMAND) {
        return blocks;
    }

    const links = project.getNodeLinks(feature, 'command_trigger');
    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `'****${doneLinks[0].getSourceId()}****'` : '';
    for (let i = 0; i < links.length; i++) {
        const link = links[i];
        const commandName = COMMAND.getSettingValue('NAME');
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `cmd_${commandName}(${project.getNodeParameter(link, 'data')})
            ${doneBlock}`,
        });
    }

    return blocks;
};
